const backToTopButton = document.querySelector('.button.back-to-top');

export function initBackToTop() {
  window.addEventListener('scroll', makeBackToTopButtonVisible);
}

function makeBackToTopButtonVisible(_event: Event) {
  if (backToTopButton) {
    if (document.body.scrollTop >= window.innerHeight || document.documentElement.scrollTop >= window.innerHeight) {
      backToTopButton.classList.add('visible');
    }
    else {
      backToTopButton.classList.remove('visible');
    }
  }
}
